// src/pages/Profile/WishlistPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useWishlist } from '../../contexts/WishlistContext';
import '../../styles/profile/WhishlistPage.css';

const WishlistPage = () => {
  const { wishlist, removeFromWishlist } = useWishlist();

  if (!wishlist.length)
    return (
      <div className="wishlist-page">
        <div className="container">
          <h1>My Wishlist</h1>
          <p>
            Your wishlist is empty. <Link to="/shop">Browse books</Link>
          </p>
        </div>
      </div>
    );

  return (
    <div className="wishlist-page">
      <div className="container">
        <h1>My Wishlist ({wishlist.length})</h1>
        <div className="wishlist-grid">
          {wishlist.map((book) => (
            <div key={book.id} className="wishlist-card">
              <div className="wishlist-card-left">
                <Link to={`/book/${book.id}`}>
                  <img
                    src={book.imageUrl || '/placeholder-book.jpg'}
                    alt={book.title}
                  />
                </Link>
              </div>

              <div className="wishlist-card-right">
                <Link to={`/book/${book.id}`} className="wishlist-book-title">
                  {book.title}
                </Link>
                <p className="wishlist-book-author">by {book.author}</p>
                <p className="wishlist-book-price">${book.price?.toFixed(2)} CAD</p>
                <button
                  className="remove-wishlist-btn"
                  onClick={() => removeFromWishlist(book.id)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WishlistPage;
